// Cross-guide rubric quality: every companion with traffic in the range, its
// rubric average and — crucially — how many of its calls were actually judged.
// The per-guide sections below only ever show one companion at a time, so this
// is the table that answers "which companion is doing worst right now?".

import type { GuideAnalyticsRow } from "../../services/analytics";
import { formatDateTime } from "../analytics/format";
import { scoreTone } from "./RubricSummary";

function pct(value: number | null): string {
  return value === null ? "—" : `${Math.round(value * 100)}%`;
}

export function GuideQualityTable({
  rows,
  selectedGuideId,
  onSelect,
}: {
  rows: GuideAnalyticsRow[];
  selectedGuideId: string;
  onSelect: (guideId: string) => void;
}) {
  if (rows.length === 0) {
    return <div className="state-box">No companion activity in this range.</div>;
  }
  return (
    <table className="guide-table">
      <thead>
        <tr>
          <th className="no-sort">Companion</th>
          <th className="no-sort">Rubric avg</th>
          <th className="no-sort">Judged</th>
          <th className="no-sort">Calls</th>
          <th className="no-sort">Last call</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((g) => (
          <tr
            key={g.guideId}
            className={`guide-row${g.guideId === selectedGuideId ? " selected" : ""}`}
            onClick={() => onSelect(g.guideId)}
          >
            <td>
              <span className="name">{g.guideName || g.guideId}</span>
            </td>
            <td>
              {g.evalCount === 0 ? (
                <span className="muted">not judged</span>
              ) : (
                <span className={`rubric-score sm ${scoreTone(g.avgEvalScore)}`}>
                  {pct(g.avgEvalScore)}
                </span>
              )}
            </td>
            {/* Denominator, always: an empty cell above means "not sampled",
                which is a very different problem from "scored badly". */}
            <td className="muted">
              {g.evalCount}/{g.calls}
            </td>
            <td>{g.calls}</td>
            <td className="voice-cell">{formatDateTime(g.lastCallAt)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
